const demoProfiles = [];
const demoUser = [];
const salesUser = [];
const demoListings = [];
const demoPopularLocations = [];
const demoSMTP = [];
const demoData = {};
const demoAdmin = {};

export {
    demoProfiles, demoUser, demoListings,
    demoPopularLocations, demoData, demoAdmin,
    salesUser, demoSMTP
}